import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {Button} from '@mui/material';
import {CheckCircle} from '@mui/icons-material';
import UpdateResultHeader from 'app/components/match/liveResult/UpdateResultHeader';
import {useSoftTickerContext} from 'app/hooks/useSoftTickerContext';
import useShowAddScorerButton from 'app/components/match/liveResult/updateScorer/useShowAddScorerButton';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${SIZES['16']};
`;

const TextContainer = styled.div<{height?: string}>`
  min-height: ${props => props.height ?? SIZES['42']};
  height: ${props => props.height ?? 'auto'};
  grid-column: span 2;
  justify-self: center;
`;

const Placeholder = styled.div`
  height: ${SIZES['8']};
  grid-column: span 2;
  @media (max-width: 330px) {
    display: none;
  }
`;

export const Actions = styled.div`
  grid-column: span 2;
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
`;

interface UpdateSuccessProps {
  match: any;
  tickerEvents: any[];
  onClose: () => void;
  onResume: () => void;
}

export default function UpdateSuccess({match, tickerEvents, onClose, onResume}: UpdateSuccessProps) {
  const {softTickerData} = useSoftTickerContext();

  const showAddScorerButton = useShowAddScorerButton(match, tickerEvents);

  return (
    <>
      <UpdateResultHeader match={match} resultData={softTickerData.resultData} />
      <Container>
        <TextContainer height={SIZES['24']}>
          <CheckCircle sx={{fontSize: 24, color: COLORS.darkGreen}} />
        </TextContainer>
        <TextContainer>
          <Typography variant='subheading' component='span'>
            Spielstand erfolgreich aktualisiert!
          </Typography>
        </TextContainer>
        {showAddScorerButton ? (
          <>
            <TextContainer>
              <Typography variant='body1'>
                Ergänze im nächsten Schritt das Torgeschehen, indem du den Torschützen hinzufügst.
              </Typography>
            </TextContainer>
            <Placeholder />
            <Actions>
              <Button variant='text' sx={{color: COLORS.darkestGrey}} onClick={onClose}>
                Schließen
              </Button>
              <Button variant='contained' color='secondary' onClick={onResume}>
                Torschütze eintragen
              </Button>
            </Actions>
          </>
        ) : (
          <>
            <TextContainer />
            <Placeholder />
            <Actions>
              <div />
              <Button variant='contained' color='secondary' onClick={onClose}>
                Schließen
              </Button>
            </Actions>
          </>
        )}
      </Container>
    </>
  );
}
